import { IDS } from '../../settings-action-id.constants';
import { TAB_SELECT, TAB_SHOW } from '../../../../../common/tabs/tabs.constants';
import * as AccreditationActions from '../../../accreditation.actions';
import * as SettingsActions from "../../settings.actions";
import * as Actions from '../evidence-list.actions';
import {TYPES} from "../../settings-action-type.constants";
import {GRID_FILTER, GRID_RELOAD} from "../../../../../common/grid/grid.constants";
import get from "lodash/get";

/**
 * Creates a new HofRequiredDocDetailsController.
 * @class
 */
export const evidenceDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, Notifier, FileActions) {
        /**
         * @function $onInit
         */
        this.$onInit = async () => {
            this.identifier = `${IDS.accSettings}.${IDS.evidenceDetails}`;
            this.parentState = IDS.app_accreditation_scheme_settings_evidence;

            this.unsubscribe = $ngRedux.connect(state => {
                const accSettings = state.accreditation.accSettings;
                const details = accSettings.evidenceDetails;
                const textId = `COMMON.DOCUMENT.CODE.${details?.type_code.toUpperCase()}`;

                let typeName = $filter('translate')(textId);
                if (typeName === textId)
                    typeName = details.type_name;

                return {
                    sectionsTree:               state.accreditation.simpleSectionsTree,
                    typeName,
                    details,
                    sample_doc_uri:             details.sample_doc_uri,
                    applicableHeadOffices:      accSettings.evidenceApplicableHeadOfficesGrid.itemsSelect,
                    allHeadOffices:            (accSettings.evidenceApplicableHeadOfficesGrid.items || []).map(item => item.uuid),
                    schemeName:                 accSettings.frameworkDetails.title,
                    assignedRequirements:           accSettings.evidenceRequirementsGrid.items,
                }
            }, {
                ...AccreditationActions,
                ...FileActions,
                ...SettingsActions,
                ...Actions,
            })(this);

            this.title = `${this.details.name}`;
            this.schemeCode = $stateParams.itemCode;


            this.getRegulatoryFrameworkDetails(this.schemeCode).then(scheme => {
                this.fetchEnabledHeadOffices(scheme.id)
            })
            this.initInputSelectsForRequirements({})
        }

            this.initInputSelectsForRequirements = ({deselectAll}) => {
            // insert data into first requirements select box
            $ngRedux.dispatch({
                type: TYPES.SELECT_CASCADE_SECTIONS,
                id: this.identifier,
                level:0,
                sections: this.sectionsTree,
                sectionId: null,
                sectionParentId: null,
            });

            let selectedLevel1Id, selectedLevel2Id, selectedLevel3Id;
            if(this.sectionId && this.sectionParentId && this.sectionSchemeCode === this.schemeCode){
                const section2 = this.findChildSectionById(this.sectionParentId, this.sectionsTree);
                selectedLevel1Id = section2.sectionParentId;
                selectedLevel2Id = this.sectionParentId;
                selectedLevel3Id = this.sectionId;
            }
            else{
                selectedLevel1Id = get(this.sectionsTree,'[0].id');
                selectedLevel2Id = get(this.sectionsTree,'[0].children[0].id');
                selectedLevel3Id = get(this.sectionsTree,'[0].children[0].children[0].id');
            }

            if(selectedLevel1Id) this.onSelectRequirement({item:{value: selectedLevel1Id}, skipGridFetch: true, deselectAll});
            if(selectedLevel2Id) this.onSelectRequirement({item:{value: selectedLevel2Id}, skipGridFetch: true, deselectAll});
            let level3Requirement;
            if(selectedLevel3Id)
                level3Requirement = this.onSelectRequirement({item:{value: selectedLevel3Id}, skipGridFetch: !!deselectAll, deselectAll});

            if(level3Requirement && deselectAll === false){
                this.getFrameworkRequirementDetails({
                    ...level3Requirement,
                    schemeCode: this.schemeCode
                });
            }
            if(deselectAll)
                $ngRedux.dispatch({
                    type:   TYPES.SELECT_CASCADE_SECTIONS_RESET,
                    id:     this.identifier,
                });
        }

        this.onHeadOfficeGridSelect = ({item}) => {
            if (!item.applicable) {
                return;
            }
            $ngRedux.dispatch({
                type: GRID_FILTER,
                id: IDS.accSettings,
                path: IDS.evidenceApplicableSitesGrid,
                filter: {
                    evg_id: this.details.ard_id,
                    hof_uuid: item.uuid,
                }
            });
            $ngRedux.dispatch({
                type: TYPES.UPDATE_SELECTED_HEAD_OFFICE_NAME,
                id: IDS.accSettings,
                selectedHeadOfficeName: item.name,
            });

            $ngRedux.dispatch({
                type: TAB_SHOW,
                id: this.parentState,
                state: IDS.app_accreditation_scheme_settings_evidence_applicable_sites,
                stateParams: { hofUuid: item.uuid }
            });
        }

        this.onSelectRequirement = ({item, skipGridFetch = undefined, deselectAll = false}) =>{
            const requirement = this.findChildSectionById(item.value, this.sectionsTree);
            const level3Requirements = requirement.level === 1 && requirement.children.length
                ? this.findChildSectionById(requirement.children[0].id, this.sectionsTree).children
                : undefined;
            $ngRedux.dispatch({
                type:       TYPES.SELECT_CASCADE_SECTIONS,
                id:         this.identifier,
                sectionId:  requirement.id,
                level:      requirement.level,
                sections:   requirement.children,
                level3Requirements,
                schemeCode: this.schemeCode
            });

            const level3Requirement =
                level3Requirements?.length && level3Requirements[0]
                || requirement.children?.length && requirement.children[0]
                || requirement;

            if(deselectAll === false) {
                this.selectedRequirement = level3Requirement.id
            }
            return level3Requirement
        }

        this.findChildSectionById = (id, sections) => {
            return sections.reduce((result, item) => {
                if(result)
                    return result;
                if(item.id === id)
                    return item
                else if (item.children.length)
                    return this.findChildSectionById(id, item.children)
            }, null);
        }

        this.onButtonDetachReqDocFromSection = ({item}) => {
            //verify that section is not last remaining section
            if (this.assignedRequirements.length === 1) {
                return
            }
            this.detachEvidenceGroupFromRequirement(this.details.ard_id, item.id, IDS.evidenceRequirementsGrid).then(() => {
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.evidenceGrid,
                })
            });
        }

        this.onButtonAssignReqDocToSection = () => {
            //verify that section is not already added
            if (this.assignedRequirements.find(item => item.id === this.selectedRequirement)) {
                return
            }
            this.assignEvidenceGroupToFrameworkRequirement(this.details.ard_id, this.selectedRequirement, IDS.evidenceRequirementsGrid).then(() => {
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.evidenceGrid,
                })
            });
        }

        this.onSampleDocUploadSave = (event) => {
            $ngRedux.dispatch({
                type: TYPES.DOCUMENT_SAMPLE_DOC_CHANGED,
                id: IDS.accSettings,
                path: IDS.evidenceDetails,
                sample_doc_uri: event[0].filePath,
            });
        }

        this.onDownloadSampleDoc = () => {
            this.download(`storage${this.sample_doc_uri}`);
        };

        this.onResetSampleDoc = () => {
            $ngRedux.dispatch({
                type: TYPES.DOCUMENT_SAMPLE_DOC_CHANGED,
                id: IDS.accSettings,
                path: IDS.evidenceDetails,
                sample_doc_uri: null,
            });
        }

        this.onSaveChangesButton = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.requiredDocumentDetailsForm');

            if (this.requiredDocumentDetailsForm.$valid === false) {
                Notifier.error('COMMON.FIELDS_REQUIRED');
                return;
            }
            if (this.applicableHeadOffices.length === 0) {
                Notifier.error('COMMON.CLIENT_RESPONSE.NO_ITEMS_SELECTED');
                return;
            }
            this.editHofEvidenceGroup({
                ard_id:                 this.details.ard_id,
                doc_num:                this.details.doc_num,
                name:                   this.details.name,
                description:            this.details.description,
                sample_doc_uri:         this.details.sample_doc_uri,
                applicable_hof_uuids:   this.applicableHeadOffices,
                non_applicable_hof_uuids: this.allHeadOffices.filter(uuid => !this.applicableHeadOffices.includes(uuid)),
                submission_org_level_code: this.details.submission_org_level_code
            }).then(() => {
                $ngRedux.dispatch({
                    type: TAB_SELECT,
                    id: this.parentState,
                    state: IDS.app_accreditation_scheme_settings_evidence_list,
                });

            })
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    },
    template: require('./evidence-details.html')
}